import { setCurrentLanguage } from '../screen/screenActions';
import { CLPL } from '../../constants/measure';
import { LANGUAGE } from '../../constants/language';

export const setLanguageForMeasure = (dispatch, flowStrategy) => {
    if (flowStrategy.measure === CLPL.MEASURE) {
        dispatch(setCurrentLanguage(LANGUAGE.SPA));
    }
};
export default setLanguageForMeasure;
